import { List } from 'immutable';
import { lruMemoize } from 'reselect';

import { isResourceLoading } from './common';

const isTagsLoading = lruMemoize(isResourceLoading);
const getTags = lruMemoize(
    (data) => data.getIn(['tags'], List()),
);

export {
    isTagsLoading,
    getTags,
};
